import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card, CardAction } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import { Checkbox } from 'rmwc/Checkbox';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import CoursePackageDetails from './CoursePackageDetails'
import ReactGA from 'react-ga';

class CoursePackageHome extends Component {

  constructor(props){
    super(props);
    this.state={
      errorMsg: '',
      validationMsg: '',
      paymentModeError: '',
      validEmailErr: '',
      isSelection: true,
      isPackageDetailDisplay: false,
      selectedPackageNameForDetail: '',
      selectedPackageIdForDetail: '',
      restrictionLength: [4,5,6,11,12,13],
      selectedRestrictionMsg: '',
      validSelection: true,

      data: {
        purchasePackages: [],
        itemAmountHash: {},
        selectedItems: [],
        finalAmount: 0,
        paymentModes: [],
        paymentModeId: '',
        firstName: '',
        lastName: '',
        email: '',
        firstNameDisable: false,
        lastNameDisable: false,
        discountDetails: [],
      },
      max: 3,
    }
    this.handleCardRedirection = this.handleCardRedirection.bind(this);
  }

  componentDidMount() {
    ReactGA.set({ userId: this.props.user.id });
    ReactGA.initialize('UA-139837993-1');
    ReactGA.pageview('/coursepackageweb');

    let entityId = this.props.match.params.id
    let data = Object.assign({}, this.state.data)
    api.getPurchasePackages(this.props.user.accessToken, entityId)
      .then((result) => {
          if(result.status === 'success'){
            data.purchasePackages = result.data
            data.itemAmountHash = this.constructitemAmountHash(result.data)
          }
          else {
            this.setState({errorMsg: 'Error in fetching the details, Please contact admin.'})
          }
          return api.getPaymentModes(this.props.user.accessToken)
        }).then((result) => {
          data.paymentModes = result
          return api.getuserForRegistration(this.props.user.accessToken)
        }).then((result) =>{
          data.firstName = result.data.firstName
          data.lastName = result.data.lastName
          data.email = result.data.email
          if(data.firstName != '')
              data.firstNameDisable = true
            if(data.firstName != '')
              data.lastNameDisable = true
          this.setState({data: data})
        })
  }

  handleCardRedirection(event, packages) {
    event.preventDefault();
    //this.props.history.push(`/portal/app/purchase/detail/${packages.name}/${packages.id}`)
    this.setState({selectedPackageIdForDetail: packages.id, selectedPackageNameForDetail: packages.name, isPackageDetailDisplay:true})
  }

  constructitemAmountHash = (moduleArray) => {
    const amountHash = {}
    {moduleArray.map(function(module) {
      amountHash[module.id]= parseFloat(module.amount)
    })}
    return amountHash
  }

  handleItemSelection = (event) => {
  
    let data = Object.assign({}, this.state.data)
    if(event.target.checked) {
      data.selectedItems.push(parseInt(event.target.value))
    } 
    else {
      data.selectedItems = data.selectedItems.filter(function(val) {return val!== parseInt(event.target.value)} );
    }
    data.finalAmount = this.calculateSelItemsAmount(data.selectedItems)
    
    let selectedRestrictionMsg = ''
    let validSelection = true
    /**if(this.state.restrictionLength.includes(data.selectedItems.length)){
      selectedRestrictionMsg = 'You can only select a combination of 1, 2, 3, 7, 8, 9, 10 or 14 modules.'
      validSelection = false
    }*/

    this.setState({data: data, validSelection: validSelection, selectedRestrictionMsg: selectedRestrictionMsg})
  }

  calculateSelItemsAmount = (selectedItemsArray) => {
    let totalAmountHash = this.state.data.itemAmountHash
    let amount = 0.0
    {selectedItemsArray.map(function(itemId){
      amount = amount + totalAmountHash[itemId]
    })}
    return amount
  }

  handleCartItemsSave = (e) => {
    e.preventDefault();
    this.processPayment(false)
  }

  handleSaveAndPay = (e) => {
    e.preventDefault();
    this.processPayment(true)
  }

  onBackToPackageHome = (e) => {
    this.setState({isPackageDetailDisplay: false})
  }

  processPayment = (isPayment) => {
    if(this.state.data.firstName === '' || this.state.data.lastName === '' || this.state.data.email === ''){
      this.setState({validationMsg: 'First Name Last Name and email are mandatory.'})
      return
    }
    const validEmail = (new RegExp(/(?!\.)(?!.*\.$)(?!.*?\.\.)[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(this.state.data.email))
    if((this.state.data.email === '') || (validEmail === false)){
        return this.setState({validEmailErr: 'Please enter the valid email'})
    }
    if(this.state.data.paymentModeId === ''){
      this.setState({paymentModeError: 'Please select the payment mode.'})
      return
    }
    let cartItemDetails = this.state.data.selectedItems
    let values, payment;
    values = {
      'cart_item_details': cartItemDetails,
      'is_payment': isPayment,
      'payment_mode_id': this.state.data.paymentModeId,
      'currency': 'RS',
      'first_name': this.state.data.firstName,
      'last_name': this.state.data.lastName,
      'email': this.state.data.email
    }

    api.handleEntititySave(this.props.user.accessToken, values)
      .then((result) => {
        if (result.status === 'success'){
          if(result.redirect_to)
          window.location.href = result.redirect_to;
          else
            this.props.history.push("/portal/app/purchase/orders")
        }
        else if(result.status === 'error') {
          this.setState({errorMsg: result.errors})
        }
        else{
          this.setState({errorMsg: result.message})
        }
      })
  }

  handlePaymentModeChange = (event) => {
    let data = Object.assign({}, this.state.data)
    data.paymentModeId = event.target.value
    this.setState({data: data})
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  handleConfirmSelection = (event) => {
    event.preventDefault();

    if(this.state.data.selectedItems.length <=0){
      this.setState({errorMsg: 'Please select atleast one item before proceeding'})
      return
    }

    let data = Object.assign({}, this.state.data)
    let cartItemDetails = this.state.data.selectedItems
    let values;
    values = {
      'cart_item_details': cartItemDetails
    }
    api.getPurchaseDiscount(this.props.user.accessToken, values)
      .then((result) => {
        if(result.status === 'success'){
          data.discountDetails = result.data
          this.setState({data: data, isSelection: false, errorMsg:''})
        }
        else if(result.status === 'error'){
          this.setState({errorMsg: result.message})
        }
        else{
          this.setState({errorMsg: 'Error in fetching the data.Please contact admin.'})
        }
      })
  }

  handleModifySelection = () => {
    const data = Object.assign({}, this.state.data);
    // data.finalAmount = 0
    this.setState({data:data, isSelection: true})
  }

  render() {
    let purchasePackages = this.state.data.purchasePackages
    let colors= ["#3db0e4","#e1c678","#e53a34"];
    let max = this.state.max;
    let count = 0;
    let handleCardRedirection = this.handleCardRedirection
    let handleItemSelection = this.handleItemSelection
    let displayComponent,amountComponent;
    let isItemSelected
    let selectedItems = this.state.data.selectedItems
    let uniqKey = Math.random()

    let oupagreementComponent
    let selectedEntityId = this.props.match.params.id

    if(selectedEntityId === '1'){
     oupagreementComponent = <div>By clicking on Order and Pay, you agree to the <a href="https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/EndUserLicencseAgreement_OUPOTT.pdf" target="_blank">Terms and Conditions</a></div>
    }


    displayComponent = (
      <div>
        <Grid>
          {purchasePackages.map(function(packages) {
            let colorIndex = count % max;
            let colorValue = colors[colorIndex]
            count++;
            let packageName = packages.name
            let name
            if(packageName.length > 80){
              name = packageName.substring(0, 80) + ".."
            }
            else{
              name = packageName
            }
            isItemSelected = selectedItems.includes(packages.id)
            return(
              <GridCell span="3" style={{paddingTop: '10px',paddingBottom: '10px'}}>
                <Card style={{backgroundColor: colorValue, color: '#ffffff',lineHeight: '1',borderRadius: '3px',height: "200px"}}>
                  <Checkbox onClick={(event) => handleItemSelection(event)} value={packages.id} checked={isItemSelected}></Checkbox>
                  <h1 style={{padding: '5px',fontSize: '16px', fontWeight: '500'}}>{name}</h1>
                  <div style={{padding: '0px',}} onClick={((e) => handleCardRedirection(e, packages))}>
                    <Grid>
                      <GridCell span="6">View Details </GridCell>
                      <GridCell span="6"><i className="material-icons">arrow_forward</i></GridCell>
                    </Grid>
                  </div>
                </Card>
              </GridCell>
            )
          })}
        </Grid>
        <Grid>
          <GridCell span="12">
            <Button raised onClick={(event) => this.handleConfirmSelection(event)}>Save Cart</Button>
          </GridCell>
        </Grid>
        <Grid>
          <GridCell span="12">
            <div style={{color: 'red'}}>{this.state.selectedRestrictionMsg} </div>
          </GridCell>
        </Grid>
      </div>
    )

    if(this.state.data.finalAmount !== 0) {
      amountComponent = (
        <Grid>
          <GridCell span="4"><p style={{fontWeight: 'bold'}}>Amount: INR {this.state.data.discountDetails.pre_discount_overall_amount} for {this.state.data.selectedItems.length} modules.</p></GridCell>
          <GridCell span="4"><p style={{fontWeight: 'bold'}}>Discount Amount: INR {this.state.data.discountDetails.actual_discount} for {this.state.data.selectedItems.length} modules.</p></GridCell>
          <GridCell span="4"><p style={{fontWeight: 'bold'}}>Final Amount: INR {this.state.data.discountDetails.final_amount} for {this.state.data.selectedItems.length} modules.</p></GridCell>
        </Grid>
        )
    }

    let saveButtonComponent, saveAndPayButtonComponent;

    if(this.state.data.selectedItems.length > 0) {
      saveButtonComponent = (<Button raised onClick={this.handleCartItemsSave}>Order</Button>)
      saveAndPayButtonComponent = (<Button raised onClick={this.handleSaveAndPay}>order and Pay</Button>)
    }

    let paymentModeComponent = (
      <Select
        name="payment_mode"
        onChange={this.handlePaymentModeChange}
        value={this.state.data.paymentModeId}
        className="select-component"
        placeholder="--Select Payment Mode--"
      >
        {this.state.data.paymentModes.map((paymentMode) => (
          <option key={paymentMode.id} value={paymentMode.id} data-name={paymentMode.name}>
            {paymentMode.name}
          </option>
        ))}
      </Select>
    )

    let selectionComponent
    let confirmationComponent
    let PackageDetailComponent

    if(this.state.isPackageDetailDisplay){
      PackageDetailComponent = <div key={uniqKey}><CoursePackageDetails id={this.state.selectedPackageIdForDetail} packageName={this.state.selectedPackageNameForDetail} onBack={this.onBackToPackageHome}/></div>
    }

    else if(this.state.isSelection) {
      selectionComponent = (
          <Card style={{padding: '25px'}}>
            <div>Modules<b></b><b><Link style={{paddingLeft: '10px'}} to="/portal/app/purchase/landing">Change Partner</Link></b></div>
           {displayComponent}
           <div style={{color: 'red'}}>{this.state.errorMsg}</div>
          </Card>
      )
    }

    else{
      confirmationComponent = (
        <div key={this.state.data.selectedItems.length}>
          <Grid>
            <GridCell span="6">
              <TextField fullwidth label="First Name" autoComplete="off" name="firstName" onChange={this.onInputChange} value={this.state.data.firstName} disabled={this.state.data.firstNameDisable} style={{ height: '150%' }}/>
            </GridCell>
            <GridCell span="6">
              <TextField fullwidth label="Last Name"  autoComplete="off"  name="lastName" onChange={this.onInputChange} value={this.state.data.lastName} disabled={this.state.data.lastNameDisable} style={{ height: '150%' }}/>
            </GridCell>
          </Grid>
          <Grid>
             <GridCell span="6">
              <TextField fullwidth label="Email" autoComplete="off"  name="email" onChange={this.onInputChange} value={this.state.data.email} style={{ height: '150%' }}/>
            </GridCell>
             <GridCell span="6"/>
          </Grid>
           {amountComponent}
          <Grid>
            <GridCell span="6">{paymentModeComponent}</GridCell>
          </Grid>
          <Grid>
            <GridCell span="12">
              {oupagreementComponent}
            </GridCell>
          </Grid>
          <Grid>
            <GridCell span="4">{saveButtonComponent}</GridCell>
            <GridCell span="4">{saveAndPayButtonComponent}</GridCell>
            <GridCell span="4"><Button raised onClick={this.handleModifySelection}>Edit Cart</Button></GridCell>
          </Grid>
          <StatusMessage error_msg = {this.state.validationMsg} />
          <StatusMessage error_msg = {this.state.paymentModeError} />
          <StatusMessage error_msg = {this.state.validEmailErr} />
        </div>
      )
    }

    

    return(
      <div hidden>
        <Grid>
          <GridCell span="12">
            <Typography use="headline6">Affiliated Programs</Typography>
          </GridCell>
        </Grid>
        {selectionComponent}
        {confirmationComponent}
        {PackageDetailComponent}
        <div style={{color: 'red'}}>{this.state.errorMsg}</div>
      </div>
    );
  }
 }

 function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(CoursePackageHome);


// WEBPACK FOOTER //
// ./src/views/purchases/CoursePackageHome.jsx